/* eslint-disable */
import React from 'react';
import { Box, Stack } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    fontSize: {
        fontSize: 20,
    },
}));

const UserMediaCircuit = (props) => {
    const { value, header } = props;

    const classes = useStyles();
    return (
        <>
            {!header ? (
                <Box display="block" alignItems={
                    value && value.align ==
                        'left'
                        ? 'flex-start'
                        : 'center'
                }>
                    {value.status === 1 && (
                        <CheckCircleRoundedIcon
                            className={classes.fontSize}
                            sx={{
                                color:
                                    value.permission == 1
                                        ? theme.palette.success.main
                                        : theme.palette.grey[500],
                            }}
                            onClick={async (event) =>
                                value.status === 1
                                    ? props.setUserPermission(
                                        props.rowIndex,
                                        props.colIndex,
                                        props.column,
                                        value.permission === 1 ? 0 : 1
                                    )
                                    : null
                            }
                        />
                    )}
                </Box>
            ) : (
                <Box display="block" alignItems={
                    value && value.align ==
                        'left'
                        ? 'flex-start'
                        : 'center'
                }>
                    {props.column.id !== 'completedOn' ? (
                        <CheckCircleRoundedIcon
                            className={classes.fontSize}
                            sx={{
                                color:
                                    props.column.permission == 1
                                        ? theme.palette.success.main
                                        : theme.palette.grey[500],
                            }}
                            onClick={(event) =>
                                props.setUserHeadPermission(
                                    props.colIndex,
                                    props.column,
                                    props.column.permission === 1 ? 0 : 1
                                )
                            }
                        />
                    ) : null}
                </Box>
            )}
        </>
    );
};

export default UserMediaCircuit;
